import { FC } from 'react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { BoxV2 as Box, Flex } from 'portal-commons';

import RcsSectionBlock from './RcsSectionBlock';
import StatusIndicator from './StatusIndicator';
import { BrandAssetStatus } from '@/apis/core';

const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);

const StatusItem: FC<{
  title: string;
  success: boolean;
  status?: string | null;
}> = ({ status, title, success }) => {
  return (
    <div>
      <Box sx={{ fontWeight: 'bold', mb: 'xxs' }}>{title}</Box>
      <div>
        {!!status && (
          <StatusIndicator variant={success ? 'success' : 'error'} />
        )}
        <span>{status ? capitalize(status) : 'N/A'}</span>
      </div>
    </div>
  );
};

interface StatusSectionProps {
  data: {
    rcsVet?: string | null;
    logo?: string | null;
    banner?: string | null;
  };
}

const StatusSection: FC<StatusSectionProps> = ({ data }) => {
  return (
    <RcsSectionBlock
      icon={faCircleCheck}
      title="Status"
      showDivider={true}
      editable={false}
    >
      <Box sx={{ color: 't.black80' }}>
        The statuses of different verification steps involved in verification of
        an RCS Campaign.
      </Box>
      <Flex
        sx={{ flexDirection: 'row', gap: '50px', mt: 'm', color: 't.black80' }}
      >
        <StatusItem
          title="RCS Vet"
          success={data.rcsVet === 'VERIFIED'}
          status={data.rcsVet}
        />
        <StatusItem
          title="Logo"
          success={data.logo === BrandAssetStatus.Verified}
          status={data.logo}
        />
        <StatusItem
          title="Banner"
          success={data.banner === BrandAssetStatus.Verified}
          status={data.banner}
        />
      </Flex>
    </RcsSectionBlock>
  );
};

export default StatusSection;
